export const uploaderStandardRouteNames = {
  EMPTY_URL: '',
  PREPARE: 'prepare',
  SEND: 'send',
  DROPBOX_CREATED: 'request-created',
  DONE: 'done',
};
